import { createFileRoute } from '@tanstack/react-router';
import { Cpu, FileText, Globe, Sliders, FlaskConical, ShieldCheck, Activity } from 'lucide-react';
import { Link } from '@tanstack/react-router';
import styles from './_auth.settings.module.css';

export const Route = createFileRoute('/_auth/settings/')({
  component: SettingsPage,
});

export default function SettingsPage() {
  return (
    <div className={styles.page}>
      <div className={styles.header}>
        <h1 className={styles.title}><Sliders size={22} /> Platform Settings</h1>
        <p className={styles.subtitle}>
          Global configuration for the enska.ai platform — applies across all partners and tenants
        </p>
      </div>

      <h2 className={styles.sectionTitle}>AI Infrastructure</h2>
      <div className={styles.grid}>
        <Link to="/settings/llm-providers" className={styles.card}>
          <div className={styles.cardIcon} style={{ background: 'rgba(16,185,129,0.12)', color: '#10b981' }}>
            <Cpu size={22} />
          </div>
          <div>
            <h3 className={styles.cardTitle}>Default LLM Providers</h3>
            <p className={styles.cardDesc}>
              Configure platform-wide Gemini, OpenAI, and Anthropic API keys. These are the fallback
              for any tenant that has not set its own provider credentials.
            </p>
          </div>
        </Link>
      </div>

      <h2 className={styles.sectionTitle}>Platform Internals</h2>
      <div className={styles.grid}>
        <Link to="/settings/admins" className={styles.card}>
          <div className={styles.cardIcon} style={{ background: 'rgba(99,102,241,0.12)', color: '#818cf8' }}>
            <ShieldCheck size={22} />
          </div>
          <div>
            <h3 className={styles.cardTitle}>Platform Admins</h3>
            <p className={styles.cardDesc}>
              Manage super admin users who have full access to the enska.ai platform.
              Invite new admins and control alert notifications.
            </p>
          </div>
        </Link>
        <Link to="/settings/audit-log" className={styles.card}>
          <div className={styles.cardIcon} style={{ background: 'rgba(107,114,128,0.12)', color: '#94a3b8' }}>
            <FileText size={22} />
          </div>
          <div>
            <h3 className={styles.cardTitle}>Platform Audit Log</h3>
            <p className={styles.cardDesc}>
              Immutable, SOC2-compliant log of all super-admin actions — partner creation,
              tenant suspension, impersonation sessions, and global config changes.
            </p>
          </div>
        </Link>
        <Link to="/system" className={styles.card}>
          <div className={styles.cardIcon} style={{ background: 'rgba(16,185,129,0.12)', color: '#34d399' }}>
            <Activity size={22} />
          </div>
          <div>
            <h3 className={styles.cardTitle}>System Health</h3>
            <p className={styles.cardDesc}>
              Live status of all API services, database connections, and infrastructure
              dependencies. Check here first when investigating an incident.
            </p>
          </div>
        </Link>
        <Link to="/regions" className={styles.card}>
          <div className={styles.cardIcon} style={{ background: 'rgba(99,102,241,0.12)', color: '#818cf8' }}>
            <Globe size={22} />
          </div>
          <div>
            <h3 className={styles.cardTitle}>Regions &amp; Infrastructure</h3>
            <p className={styles.cardDesc}>
              View deployment regions, set data-residency rules, and manage
              the availability zones the platform runs in.
            </p>
          </div>
        </Link>
        <Link to="/settings/api-tester" className={styles.card}>
          <div className={styles.cardIcon} style={{ background: 'rgba(99,102,241,0.12)', color: '#818cf8' }}>
            <FlaskConical size={22} />
          </div>
          <div>
            <h3 className={styles.cardTitle}>API Endpoint Tester</h3>
            <p className={styles.cardDesc}>
              Verify all backend API endpoints are responding correctly. Run individual checks
              or a full sweep across every route and see status, latency, and response payloads.
            </p>
          </div>
        </Link>
      </div>
    </div>
  );
}
